import { stipAxios } from '../axios';
import { EXTERNAL_CONTEXT } from 'app/config/urls';
import helpers from 'app/utils/helpers';

const BASE_ENDPOINT = '/veiculo';

const vehicleEndpoints = {
    getDadosAtualizadosParaAlteracao: ({ placaChassiRenavam, obterDadosOriginais }) =>
        stipAxios.post(`${EXTERNAL_CONTEXT}${BASE_ENDPOINT}/detran/dadosParaAlteracao`, {
            placaChassiRenavam,
            obterDadosOriginais,
        }),
    getVehicleInfosDetran: (placaChassiRenavam) =>
        stipAxios.get(`${EXTERNAL_CONTEXT}${BASE_ENDPOINT}/detran/${placaChassiRenavam}`),
    getSubSystems: () => stipAxios.get(`${EXTERNAL_CONTEXT}${BASE_ENDPOINT}/subsistema`),
    getAccessibilityType: () => stipAxios.get(`${EXTERNAL_CONTEXT}${BASE_ENDPOINT}/tipoacessibilidade`),
    getFuelType: () => stipAxios.get(`${EXTERNAL_CONTEXT}${BASE_ENDPOINT}/tipocombustivel`),
    getVehicleType: () => stipAxios.get(`${EXTERNAL_CONTEXT}${BASE_ENDPOINT}/tipoveiculo`),
    getVehicleCategories: () => stipAxios.get(`${EXTERNAL_CONTEXT}${BASE_ENDPOINT}/categoria`),
    getVehicleBrands: () => stipAxios.get(`${EXTERNAL_CONTEXT}${BASE_ENDPOINT}/marca`),
    getVehicleModels: () => stipAxios.get(`${EXTERNAL_CONTEXT}${BASE_ENDPOINT}/modelo`),
    getVehicleClassification: () => stipAxios.get(`${EXTERNAL_CONTEXT}${BASE_ENDPOINT}/classificacaoveiculo`),
    getTotalVehicles: () => stipAxios.get(`${EXTERNAL_CONTEXT}${BASE_ENDPOINT}/total`),
    getAllVehiclesPlate: (context = EXTERNAL_CONTEXT) => {
        return stipAxios.get(`${context}/veiculo/find-all-placas`);
    },
    getVehicleCertificate: (cdVeiculo) =>
        stipAxios.get(`${EXTERNAL_CONTEXT}${BASE_ENDPOINT}/certificado-vistoria/${cdVeiculo}`),
    getVehicle: (cdVeiculo) => stipAxios.get(`${EXTERNAL_CONTEXT}${BASE_ENDPOINT}/${cdVeiculo}`),
    getVehiclesPlatesByCompany: (cdEmpresa) => {
        if (cdEmpresa) {
            return stipAxios.get(`${BASE_ENDPOINT}/find-all-placas-by-empresa/${cdEmpresa}`);
        }
        return stipAxios.get(`${EXTERNAL_CONTEXT}${BASE_ENDPOINT}/find-all-placas-by-empresa`);
    },
    getVehiclesPlate: (context = EXTERNAL_CONTEXT) => {
        return stipAxios.get(`${context}${BASE_ENDPOINT}/find-all-placas-by-empresa`);
    },
    getVehiclesByPlate: (dePlaca, cdEmpresa) => {
        if (cdEmpresa) {
            return stipAxios.get(`${BASE_ENDPOINT}/find-by-placa-and-empresa/${dePlaca}/${cdEmpresa}`);
        }
        return stipAxios.get(`${EXTERNAL_CONTEXT}${BASE_ENDPOINT}/find-by-placa/${dePlaca}`);
    },
    getVehicles: (params, context = EXTERNAL_CONTEXT) => {
        const { page, size, request } = params;
        return stipAxios.post(`${context}${BASE_ENDPOINT}/pages/${page}/${size ? size : 10}`, request);
    },
    getInspectedVehicles: () => {
        return stipAxios.get(`${EXTERNAL_CONTEXT}${BASE_ENDPOINT}/vistoriados`);
    },
    getInspectedVehiclesByDocument: (cpfCnpj) => {
        return stipAxios.get(`${EXTERNAL_CONTEXT}${BASE_ENDPOINT}/vistoriados/${helpers.somenteAlfanumericos(cpfCnpj)}`);
    },
    getTotalInfractions: () => stipAxios.get(`/ext${BASE_ENDPOINT}/autoinfracao/total`),
    getInfractions: (params, context = EXTERNAL_CONTEXT) => {
        const { page, size, request } = params;
        return stipAxios.post(`${context}${BASE_ENDPOINT}/autoinfracao/pages/${page}/${size ? size : 10}`, request);
    },
    existeComOperadorAtivo: (placaRenavam) =>
        stipAxios.get(`${EXTERNAL_CONTEXT}${BASE_ENDPOINT}/existe-com-operador-ativo/${placaRenavam}`),
    existeSolicitacaoEmAndamento: (placaRenavam, params = {}) =>
        stipAxios.get(`${EXTERNAL_CONTEXT}${BASE_ENDPOINT}/existe-solicitacao-em-andamento/${placaRenavam}`, params),
    saveRequest: (payload, context = EXTERNAL_CONTEXT) =>
        stipAxios.post(`${context}/solicitacao/veiculos/save`, payload),
    finishRequest: (cdSolicitacao) =>
        stipAxios.put(`${EXTERNAL_CONTEXT}/solicitacao/veiculos/finalizar/${cdSolicitacao}`, {}),
    cancelRequest: (cdSolicitacao, payload = {}, context = EXTERNAL_CONTEXT) =>
        stipAxios.put(`${context}/solicitacao/veiculos/cancelar/${cdSolicitacao}`, payload),
    getVehiclesDocuments: (cdServico) => stipAxios.get(`${EXTERNAL_CONTEXT}/veiculo/documentos-licenca/${cdServico}`),
    getVehiclesDocumentsSurvey: () => stipAxios.get(`${EXTERNAL_CONTEXT}/veiculo/documentos-vistoria`),

    saveVehicle: (payload) => stipAxios.post(`${BASE_ENDPOINT}/save`, payload),
};
export default vehicleEndpoints;
